import React, { useEffect } from "react";
import Highcharts from "highcharts";
import "../sps/crps.css";

const GapSolutionScatterChart = (props: any) => {
  let { a3GAPSolutionData, chartId, isPrint } = props;
  let chartIdV = chartId ? chartId : "chart-sa";
  let graphData = a3GAPSolutionData.map((obj: any) => {
    return {
      name: `${obj.solutionId}: ${obj.solution}`,
      data: [[parseInt(obj.difficulty), parseInt(obj.benefit)]],
    };
  });

  useEffect(() => {
    let bgClr = "#2a2a2a";
    let  txtClr = "white";
    if (isPrint) {
      bgClr = "#fff";
    txtClr = "#000";
    }

    const chartOptions = {
      chart: {
        type: "scatter",
        backgroundColor: bgClr,
      },
      title: {
        text: "",
      },
      xAxis: {
        title: {
          text:
            '<div style="color:' +
            txtClr +
            ';"> Low    &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;     Difficulty    &ensp;&ensp;&ensp; &ensp;&ensp; &ensp;&ensp;&ensp;&ensp;&ensp;&ensp; &ensp;&ensp; &ensp;&ensp; &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;High</div>',
        },
        min: 0,
        max: 10,
        labels: {
          enabled: false, // Hide the axis labels
          useHTML: true, //set to true
        },

        plotLines: [
          {
            value: 5,
            color: txtClr,
            width: 2,
            zIndex: 10,
          },
        ],
      },
      yAxis: {
        title: {
          text:
            '<div style="color:' +
            txtClr +
            ';"> Low   &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;  Benifit    &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;High</div>',
        },
        min: 0,
        max: 10,
        labels: {
          enabled: false, // Hide the axis labels
        },

        plotLines: [
          {
            value: 5,
            color: txtClr,
            width: 2,
            zIndex: 10,
          },
        ],
      },
      plotOptions: {
        scatter: {
          marker: {
            radius: 5,
            symbol: "circle",
          },
          tooltip: {
            pointFormat: "<b></b>",
          },
        },
      },
      legend: {
        enabled: false, // Hide the series names
      },
      series: graphData,
      useHTML: true,
    };

    Highcharts.chart(chartIdV, chartOptions);
  }, [a3GAPSolutionData]);

  return <div id={chartIdV}></div>;
};

export default GapSolutionScatterChart;
